import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const bovisync: ImportTypeConfig = {
  dateFormat: { default: 'YYYY-MM-DD' },
  importType: true,
  instructions: {
    software: 'Bovisync',
    spreadsheetName: { lower: true, messageKey: 'exportable' },
  },
  type: 'bovisync',
}
